import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { MultilanguageContent } from '@plugins/shared/types/multilanguage';

import { MultilanguageService } from './multilanguage.service';

@Pipe({
  name: 'multilanguage',
  standalone: true,
})
export class MultilanguagePipe<T> implements PipeTransform {
  private multilanguageService = inject(MultilanguageService);

  transform(
    value: MultilanguageContent<T>,
    type: 'current' | 'preferred' = 'current',
  ): Observable<T> {
    if (type === 'preferred') {
      return this.multilanguageService.preferredLanguage$.pipe(
        map((lang) => value[lang]),
        switchMap((val) =>
          typeof val === 'undefined' ? this.currentLanguage$(value) : of(val),
        ),
      );
    }
    return this.currentLanguage$(value);
  }

  private currentLanguage$(value: MultilanguageContent<T>) {
    return this.multilanguageService.currentLanguage$.pipe(
      map((lang) => value[lang]),
    );
  }
}
